import { SVGProps, Ref, forwardRef } from 'react';

export const BellFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.62 21.428c2.2-4.172 7.298-15.48.38-19.5C12.082-2.093 4.9 8.013 2.413 12.014zM8.282 17.504c-.32 2.425.234 4.71 2.65 5.357 1.707.457 3.018-.257 3.97-1.512z"
            fill="currentColor"
        />
    </svg>
));
BellFilledSize24Glyph.displayName = 'BellFilledSize24Glyph';
